<template>
  <div class="position-relative">
    <button
      v-tooltip.right="$t('CHAT_LIST.SORT_TOOLTIP_LABEL')"
      class="sort-btn"
      :class="{ 'is-open': showActionsDropdown }"
      @click="toggleDropdown"
    >
      <span class="sort-btn__label">{{ sortLabel }}</span>
      <svg class="sort-btn__caret" viewBox="0 0 24 24">
        <path d="m6 9 6 6 6-6" />
      </svg>
    </button>
    <div
      v-if="showActionsDropdown"
      v-on-clickaway="closeDropdown"
      class="dropdown-pane dropdown-pane--open basic-filter"
    >
      <div class="filter__item">
        <span>{{ this.$t('CHAT_LIST.CHAT_SORT.STATUS') }}</span>
        <filter-item
          type="status"
          :selected-value="chatStatus"
          :items="chatStatusItems"
          path-prefix="CHAT_LIST.CHAT_STATUS_FILTER_ITEMS"
          @onChangeFilter="onChangeFilter"
        />
      </div>
      <div v-if="activeInbox" class="filter__item">
        <span>{{ this.$t('CHAT_LIST.CHAT_SORT.CLASSIFICATION') }}</span>
        <filter-item
          type="classification"
          :selected-value="classificationFilter"
          :classification-items="chatClassification"
          path-prefix="CHAT_LIST.CHAT_SORT_FILTER_ITEMS"
          @onChangeFilter="onChangeFilter"
        />
      </div>
      <div class="filter__item">
        <span>{{ this.$t('CHAT_LIST.CHAT_SORT.ORDER_BY') }}</span>
        <filter-item
          type="sort"
          :selected-value="chatSortFilter"
          :items="chatSortItems"
          path-prefix="CHAT_LIST.CHAT_SORT_FILTER_ITEMS"
          @onChangeFilter="onChangeFilter"
        />
      </div>
      
        <div class="filter__item">
          <span>{{ $t('CHAT_LIST.CHAT_SORT.READ_STATUS') }}</span>
          <filter-item
            type="read_status"
            :selected-value="readStatusFilter"
            :items="readStatusItems"
            path-prefix="CHAT_LIST.CHAT_SORT_READ_STATUS_ITEMS"
            @onChangeFilter="onChangeFilter"
          />
        </div>
    </div>
  </div>
</template>

<script>
import wootConstants from 'dashboard/constants/globals';
import { mixin as clickaway } from 'vue-clickaway';
import { mapGetters } from 'vuex';
import FilterItem from './FilterItem';
import router from '../../../routes';
import { closeConversation } from '../../../helper/URLHelper';

export default {
  components: {
    FilterItem,
  },
  mixins: [clickaway],
  data() {
    return {
      showActionsDropdown: false,
      chatStatusItems: this.$t('CHAT_LIST.CHAT_STATUS_FILTER_ITEMS'),
      chatSortItems: this.$t('CHAT_LIST.CHAT_SORT_FILTER_ITEMS'),
      chatClassificationItems: this.$t('CHAT_LIST.CHAT_CLASSIFICATION_FILTER_ITEMS'),
    };
  },
  computed: {
    ...mapGetters({
      chatStatusFilter: 'getChatStatusFilter',
      chatSortFilter: 'getChatSortFilter',
      activeInbox: 'getSelectedInbox',
      accountId: 'getCurrentAccountId',
      chatClassificationFilter: 'getChatClassificationFilter',
      chatClassification: 'getChatClassification',
      readStatusFilter: 'getReadStatusFilter'

    }),
    readStatusItems() {
      return [
        { key: null, label: this.$t('CHAT_LIST.CHAT_SORT_READ_STATUS_ITEMS.all.TEXT') },
        { key: 'read', label: this.$t('CHAT_LIST.CHAT_SORT_READ_STATUS_ITEMS.read.TEXT') },
        { key: 'unread', label: this.$t('CHAT_LIST.CHAT_SORT_READ_STATUS_ITEMS.unread.TEXT') },
      ];
    },
    chatStatus() {
      return this.chatStatusFilter || wootConstants.STATUS_TYPE.OPEN;
    },
    sortFilter() {
      return this.chatSortFilter || wootConstants.SORT_BY_TYPE.LATEST;
    },
    sortLabel() {
      // Mostra a visualização selecionada no gatilho (ex.: "Última Atividade"),
      // igual ao .sort-btn do protótipo em vez de só o ícone de setinhas
      const key = this.chatSortFilter || wootConstants.SORT_BY_TYPE.LATEST;
      return this.$t(`CHAT_LIST.CHAT_SORT_FILTER_ITEMS.${key}.TEXT`);
    },
    classificationFilter() {
      return this.activeInbox ? this.chatClassificationFilter : wootConstants.CLASSIFICATION_TYPE.ALL;
    },
  },
  methods: {
    onTabChange(value) {
      this.$emit('changeFilter', value);
      this.closeDropdown();
    },
    toggleDropdown() {
      this.showActionsDropdown = !this.showActionsDropdown;
    },
    closeDropdown() {
      this.showActionsDropdown = false;
    },
    onChangeFilter(type, value) {
      if (value === 'classification'){
        closeConversation(this.accountId, router,0,null,this.activeInbox);
      }
      //
      this.$emit('changeFilter', type, value);
    },
  },
};
</script>
<style lang="scss" scoped>
// Gatilho de ordenação: texto da opção selecionada + chevron (igual .sort-btn do protótipo)
.sort-btn {
  display: flex;
  align-items: center;
  gap: var(--space-smaller);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  color: var(--s-600);
  padding: var(--space-micro) var(--space-smaller);
  border-radius: var(--border-radius-normal);
  cursor: pointer;
  transition: color 0.15s ease-in-out, background 0.15s ease-in-out;

  &:hover,
  &.is-open {
    color: var(--s-800);
    background: var(--s-50);
  }

  .sort-btn__caret {
    width: 14px;
    height: 14px;
    flex: none;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
}

.basic-filter {
  margin-top: var(--space-smaller);
  padding: var(--space-normal);
  right: -5px;
  width: 21rem;

  span {
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-medium);
  }

  .filter__item {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: var(--space-normal);

    &:first-child {
      margin-top: 0;
    }

    span {
      font-size: var(--font-size-mini);
    }
  }
}

.icon {
  margin-right: var(--space-smaller);
}

.dropdown-icon {
  margin-left: var(--space-smaller);
}
</style>
